import React from "react";
import '../About.css';
import SideImage from '../assets/Foto Llave.png';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1>Airasca & Asoc.</h1>
        <p>
          Airasca & Asoc. es un estudio jurídico e inmobiliario con sede en el centro de la ciudad
          de Río Segundo. Se especializa en juicios sucesorios, declaratorias de herederos y
          gestión de operaciones inmobiliarias como compraventa y alquiler de propiedades.
          Su enfoque combina asesoramiento legal con servicios inmobiliarios, permitiendo un
          abordaje integral en temas patrimoniales y jurídicos. La atención es personalizada y se
          basa en la experiencia profesional adquirida a lo largo de más de dos décadas de trabajo.
        </p>
        <p>
          <strong>Servicios:</strong> Juicios Sucesorios, Declaratoria de Herederos, Divorcios, Juicios Ejecutivos,
          Jubilaciones, Pensiones, Juicios de Reajuste, administración y venta de propiedades,
          tanto urbanas como rurales.
        </p>
      </div>
      <div className="about-content">
        <img src={SideImage} alt="GA Airasca & Asoc." className="about-image" />
        <div className="about-text">
          <h2>Nuestra Historia</h2>
          <p>
            Grisel Airasca es Abogada y Procuradora, egresada de la Facultad de Derecho y Ciencias
            Sociales de la Universidad Nacional de Córdoba. Inició su actividad profesional en 1997
            en sociedad con un colega. En 2006 se independizó y fundó el estudio Airasca & Asoc.
            Un año después incorporó formalmente la actividad inmobiliaria tras obtener la
            matrícula de Corredora Pública.
          </p>
          <p>
            A lo largo de su carrera, Grisel Airasca participó en múltiples cursos, jornadas y
            diplomaturas relacionadas con el Derecho Civil, de Familia y Previsional. En 2011 obtuvo
            la Diplomatura en Derecho de la Seguridad Social. Además, en 2021 completó el curso
            REAP (Real Estate Advanced Practices) y es miembro CRS (Certified Residential
            Specialist), la titulación más prestigiosa para agentes inmobiliarios a nivel
            internacional. En 2022 sumó a su formación el curso de Perito Tasador a través del
            Colegio de Corredores y Martilleros de Córdoba.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;